export const creditRequestEn = {
  //BEGIN Michael
  CREDIT_EXPIRATION: 'Credit Expiration',
  UNIT_TIME: 'Unit Time',
  PROVINCE: 'Province',
  REGION: 'Region',
  DISTRICT: 'District',
  REQUESTED_CREDIT_LIMIT: 'Requested Credit Limit',
  REQUESTED_AMOUNT: 'Requested Amount',
  REQUESTED_RELATIONSHIP_CREDIT_LIMIT: 'Requested Relationship Credit Limit',
  //END Michael
  CREDIT_REQUEST: 'Credit Request',
  CREDIT_CHECK: 'Credit Check',
  DEBTORS_REQUEST: 'Debtor Request',
  INTERNAL_CREDIT_REQUEST: 'Internal Credit Request',
  CREDIT_EXP: 'Credit Exp',
  USERNAME: 'Username',
  REQUESTED_BY: 'Requested By',
  REQUESTED_ON: 'Requested On',
  UPDATED_BY: 'Updated By',
  DEBTOR_NAME: 'Debtor Name',
  CREDIT_REQUEST_INFORMATION: 'Credit Request Information',
  DEBTOR_REQUEST_INFORMATION: 'Debtor Request Information',
  INTERNAL_CREDIT_UPDATE_REQUEST_INFORMATION: 'Internal Credit Update Request',
  APPROVE_REQUEST: 'Approve Request',
  THE_REQUEST_WAS_APPROVED_SUCCESSFULLY: 'The Credit Request was approved successfully',
  THE_REQUEST_WAS_DENIED_SUCCESSFULLY: 'The Credit Request was denied successfully',
  THE_REQUEST_WAS_DELETED_SUCCESSFULLY: 'The Credit Request was deleted successfully',
  ERROR_UPDATING_CREDIT_REQUEST: 'Error updating credit request',
  COUNTRY: 'Country',
  STATE: 'State',
  CITY: 'City',
  ZIP: 'Zip',
  EMAIL: 'Email',
  PHONE: 'Phone',
  CLIENT: 'Client',
  CLIENT_INFORMATION: 'Client Information',
  CLIENT_DEBTOR: 'Client Debtor',
  BROKER: 'Broker',
  BROKER_INFORMATION: 'Broker Information',
  BROKER_DEBTOR: 'Broker Debtor',
  DEBTOR: 'Debtor',
  DEBTOR_INFORMATION: 'Debtor Information',

  REQUIRES_ADMIN_APPROVE: 'An Admin has to approve these changes',
  REQUIRES_ADMIN_APPROVE_DETAIL:
    'These changes will not appear in the credit information section until an Admin user approves it',
  OUTDATED_REQUEST: 'Outdated Request',
  OUTDATED_CREDIT_UPDATE_REQUEST_DESCRIPTION:
    'This request is outdated because the credit information has been updated since this request was made, a new request is required',
  CHANGES_REQUESTED: 'Changes Requested',
  UPDATE_INTERNAL_CREDIT_REQUEST_WARNING:
    'By approving this request, all pending Override requests for this company will be marked as outdated',
  DELETE_CREDIT_REQUEST: 'Are you sure you want to delete this credit request?',
  MESSAGE_DELETE_CREDIT_REQUEST: 'This action cannot be undone',
  REQUEST_TYPE: 'Request Type',
  INCREASE: 'Increase',
  NEW_VALUE: 'Override',
  CREDIT_LIMIT_INCREASE: 'Credit Limit Increase',
  NEW_CREDIT_LIMIT: 'New Credit Limit',
  CURRENT_CREDIT_LIMIT: 'Current Credit Limit',
  CREDIT_LIMIT_INCREASE_AMOUNT: 'Credit Limit Increase Amount',
  CREDIT_LIMIT_MODE_INCREASE_INFO: 'The entered amount will be added to the current Credit Limit',
  CREDIT_LIMIT_MODE_OVERRIDE_INFO: 'The entered amount will replace the current Credit Limit',
  REQUEST_CREDIT_INCREASE: 'Request Credit Increase',
  CREDIT_INCREASE_REQUEST_TITLE: 'Request Credit Limit Increase',
  REQUIRED_CREDIT_LIMIT: 'Required Credit Limit',
  CREDIT_INCREASE_SUBMITTED: 'Credit increase request submitted successfully',
  FUNDING_BATCH_INVOICE_COUNT: 'Invoices in Funding Batch',
  CREDIT_LIMIT_WILL_BE_EXCEEDED:
    '{companyName}: Credit limit of {creditLimit} will be exceeded. New approved amount: {newApprovedAmount}',
  FUNDING_CREDIT_LIMIT_INSUFFICIENT_WARNING:
    'The requested increase amount will not be sufficient given the current credit limit. A larger amount will be applied to reach the required approval amount for the invoice batch.',
  ORIGINAL_CREDIT_LIMIT_INCREASE: 'Original Credit Limit Increase',
  NEW_CREDIT_LIMIT_INCREASE: 'New Credit Limit Increase',
  CREDIT_INCREASE_REQUEST_RELATION_TITLE: 'Request Relationship Credit Limit Increase',
  SEND_REQUEST: 'Send Request',
  AMOUNT_MUST_BE_GREATER_THAN_ZERO: 'Amount must be greater than 0',
  FUNDING_BATCH_INVOICE_AMOUNT: 'Invoice Batch Amount',
  CREDIT_LIMIT_ACTIVATION_INCLUDED: 'This request will also activate the credit limit, as it is currently inactive',
  LOADING_CREDIT_LIMIT_INFO: 'Loading credit limit information...',
  POSSIBLE_DUPLICATE_DEBTOR_TITLE: 'Possible duplicate debtor found',
  POSSIBLE_DUPLICATE_DEBTOR_WARNING:
    'Review the matches below and choose whether to connect to an existing debtor or create a new one.',
  POSSIBLE_DUPLICATE_DEBTOR_WARNING_CREATE:
    'This debtor may already exist. Review the matches below before creating a new one.',
  CREATE_NEW_DEBTOR: 'Create a new debtor',
  OR_DIVIDER: 'OR',
  CONNECT_TO_EXISTING_DEBTOR: 'Connect to existing debtor',
  MATCH_REASON_MC_NUMBER: 'MC Number match',
  MATCH_REASON_DOT_NUMBER: 'DOT Number match',
  MATCH_REASON_NAME_SIMILARITY: 'Name match',
}

export const creditRequestEs: typeof creditRequestEn = {
  //BEGIN Michael
  CREDIT_EXPIRATION: 'Vencimiento de Crédito',
  UNIT_TIME: 'Unidad de Tiempo',
  PROVINCE: 'Provincia',
  REGION: 'Región',
  DISTRICT: 'Distrito',
  REQUESTED_CREDIT_LIMIT: 'Límite de Crédito Solicitado',
  REQUESTED_AMOUNT: 'Monto Solicitado',
  REQUESTED_RELATIONSHIP_CREDIT_LIMIT: 'Límite de Crédito de Relación Solicitado',
  //END Michael
  CREDIT_REQUEST: 'Solicitud de Crédito',
  CREDIT_CHECK: 'Verificación de Crédito',
  DEBTORS_REQUEST: 'Solicitud de Deudor',
  INTERNAL_CREDIT_REQUEST: 'Solicitud Interna de Crédito',
  CREDIT_EXP: 'Venc. Crédito',
  USERNAME: 'Nombre de Usuario',
  REQUESTED_BY: 'Solicitado Por',
  REQUESTED_ON: 'Solicitado En',
  UPDATED_BY: 'Actualizado Por',
  DEBTOR_NAME: 'Nombre del Deudor',
  CREDIT_REQUEST_INFORMATION: 'Información de Solicitud de Crédito',
  DEBTOR_REQUEST_INFORMATION: 'Información de Solicitud de Deudor',
  INTERNAL_CREDIT_UPDATE_REQUEST_INFORMATION: 'Solicitud Interna de Actualización de Crédito',
  APPROVE_REQUEST: 'Aprobar Solicitud',
  THE_REQUEST_WAS_APPROVED_SUCCESSFULLY: 'La solicitud fue aprobada exitosamente',
  THE_REQUEST_WAS_DENIED_SUCCESSFULLY: 'La solicitud fue denegada exitosamente',
  THE_REQUEST_WAS_DELETED_SUCCESSFULLY: 'La solicitud fue eliminada exitosamente',
  ERROR_UPDATING_CREDIT_REQUEST: 'Error actualizando la solicitud de crédito',
  COUNTRY: 'País',
  STATE: 'Estado',
  CITY: 'Ciudad',
  ZIP: 'Código Postal',
  EMAIL: 'Correo Electrónico',
  PHONE: 'Teléfono',
  CLIENT: 'Cliente',
  CLIENT_INFORMATION: 'Información del Cliente',
  CLIENT_DEBTOR: 'Cliente Deudor',
  BROKER: 'Corredor',
  BROKER_INFORMATION: 'Información del Corredor',
  BROKER_DEBTOR: 'Corredor Deudor',
  DEBTOR: 'Deudor',
  DEBTOR_INFORMATION: 'Información del Deudor',

  REQUIRES_ADMIN_APPROVE: 'Un administrador debe aprobar estos cambios',
  REQUIRES_ADMIN_APPROVE_DETAIL:
    'Estos cambios no aparecerán en la sección de información de crédito hasta que un usuario administrador los apruebe',
  OUTDATED_REQUEST: 'Solicitud Desactualizada',
  OUTDATED_CREDIT_UPDATE_REQUEST_DESCRIPTION:
    'Esta solicitud está obsoleta porque la información de crédito ha sido actualizada desde que se solicitaron estos cambios, se requiere crear una nueva solicitud',
  CHANGES_REQUESTED: 'Cambios Solicitados',
  UPDATE_INTERNAL_CREDIT_REQUEST_WARNING:
    'Al aprobar esta solicitud, todas las solicitudes pendientes de tipo Reemplazar para esta empresa serán marcadas como desactualizadas',
  DELETE_CREDIT_REQUEST: '¿Estás seguro de que deseas eliminar esta solicitud de crédito?',
  MESSAGE_DELETE_CREDIT_REQUEST: 'Esta acción no se puede deshacer',
  REQUEST_TYPE: 'Tipo de Solicitud',
  INCREASE: 'Aumento',
  NEW_VALUE: 'Reemplazar',
  CREDIT_LIMIT_INCREASE: 'Aumento de Límite de Crédito',
  NEW_CREDIT_LIMIT: 'Nuevo Límite de Crédito',
  CURRENT_CREDIT_LIMIT: 'Límite de Crédito Actual',
  CREDIT_LIMIT_INCREASE_AMOUNT: 'Monto de Aumento de Límite de Crédito',
  CREDIT_LIMIT_MODE_INCREASE_INFO: 'El monto ingresado se sumará al Límite de Crédito actual',
  CREDIT_LIMIT_MODE_OVERRIDE_INFO: 'El monto ingresado reemplazará el Límite de Crédito actual',
  REQUEST_CREDIT_INCREASE: 'Solicitar Aumento de Crédito',
  CREDIT_INCREASE_REQUEST_TITLE: 'Solicitar Aumento de Límite de Crédito',
  REQUIRED_CREDIT_LIMIT: 'Límite de Crédito Requerido',
  CREDIT_INCREASE_SUBMITTED: 'Solicitud de aumento de crédito enviada exitosamente',
  FUNDING_BATCH_INVOICE_COUNT: 'Facturas en el Lote de Financiamiento',
  CREDIT_LIMIT_WILL_BE_EXCEEDED:
    '{companyName}: El límite de crédito de {creditLimit} será excedido. Nuevo monto aprobado: {newApprovedAmount}',
  FUNDING_CREDIT_LIMIT_INSUFFICIENT_WARNING:
    'El monto de aumento solicitado no será suficiente dado el límite de crédito actual. Se aplicará un monto mayor para alcanzar el monto requerido para la aprobación de facturas.',
  ORIGINAL_CREDIT_LIMIT_INCREASE: 'Aumento de Límite de Crédito Original',
  NEW_CREDIT_LIMIT_INCREASE: 'Nuevo Aumento de Límite de Crédito',
  CREDIT_INCREASE_REQUEST_RELATION_TITLE: 'Solicitar Aumento de Límite de Crédito de Relación',
  SEND_REQUEST: 'Enviar Solicitud',
  AMOUNT_MUST_BE_GREATER_THAN_ZERO: 'El monto debe ser mayor a 0',
  FUNDING_BATCH_INVOICE_AMOUNT: 'Monto Total de Facturas',
  CREDIT_LIMIT_ACTIVATION_INCLUDED: 'Esta solicitud también activará el límite de crédito, ya que actualmente está inactivo',
  LOADING_CREDIT_LIMIT_INFO: 'Cargando información de límites de crédito...',
  POSSIBLE_DUPLICATE_DEBTOR_TITLE: 'Se encontró un posible deudor duplicado',
  POSSIBLE_DUPLICATE_DEBTOR_WARNING:
    'Revisá las coincidencias y elegí si querés conectar a un deudor existente o crear uno nuevo.',
  POSSIBLE_DUPLICATE_DEBTOR_WARNING_CREATE:
    'Este deudor podría ya existir. Revisá las coincidencias antes de crear uno nuevo.',
  CREATE_NEW_DEBTOR: 'Crear un nuevo deudor',
  OR_DIVIDER: 'O',
  CONNECT_TO_EXISTING_DEBTOR: 'Conectar a un deudor existente',
  MATCH_REASON_MC_NUMBER: 'Coincidencia de número MC',
  MATCH_REASON_DOT_NUMBER: 'Coincidencia de número DOT',
  MATCH_REASON_NAME_SIMILARITY: 'Coincidencia de nombre',
}
